import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
	dismissNotification,
	markAllAsRead,
	markAsRead,
	setArchivedNotifications,
	setUnreadCount,
	setUnreadNotifications
} from "../../Reducers/default-reducers/notificationReducer"
import { useNotificationService } from "../../Services/default/NotificationSGPService"

export function useNotifications(notificationSocket) {
	const dispatch = useDispatch()
	const {
		getNotificationsForUser,
		markAsRead: markAsReadAPI,
		dismissNotification: dismissNotificationAPI,
		markAllAsRead: markAllAsReadAPI,
		getUnreadNotificationsForUser,
		getArchivedNotificationsForUser,
	} = useNotificationService()

	const { unreadNotifications, archivedNotifications, unreadCount } =
		useSelector((state) => state.notification)
	const { userId: loggedUserId } = useSelector((state) => state.global)
	// ⚡ Um único GET /user/:userId/unread retorna { notifications, count }
	const loadInitialNotifications = useCallback(
		async (userId) => {
			const { notifications, count } = await getUnreadNotificationsForUser(
				userId
			)
			dispatch(setUnreadNotifications(notifications))
			dispatch(setUnreadCount(count))
		},
		[dispatch, getUnreadNotificationsForUser]
	)
	const loadArchivedNotifications = useCallback(async () => {
		const archivedNotifications = await getArchivedNotificationsForUser(
			loggedUserId
		)

		dispatch(setArchivedNotifications(archivedNotifications))
	}, [dispatch, getArchivedNotificationsForUser])

	// Marcar como lida — dispatch otimista, depois API + socket
	const handleMarkAsRead = useCallback(async (id) => {
		dispatch(markAsRead(id))

		if (notificationSocket?.connected) {
			notificationSocket.emit("central_notification_ack", { notificationId: id })
		}
		try {
			await markAsReadAPI(id)
		} catch (_) {
			// API pode não existir para notificações central; Redux já atualizou
		}
	}, [dispatch, notificationSocket, markAsReadAPI])

	// Descartar — dispatch otimista, depois API
	const handleDismiss = useCallback(async (id) => {
		dispatch(dismissNotification(id))

		try {
			await dismissNotificationAPI(id)
		} catch (_) {}
	}, [dispatch, dismissNotificationAPI])

	// Marcar todas como lidas — captura IDs antes do dispatch
	const handleMarkAllAsRead = useCallback(async () => {
		const ids = unreadNotifications
			.map((n) => n.deliveryId ?? n._id ?? n.id)
			.filter(Boolean)
		if (ids.length === 0) return

		dispatch(markAllAsRead(ids))

		if (notificationSocket?.connected) {
			ids.forEach((notificationId) => {
				notificationSocket.emit("central_notification_ack", { notificationId })
			})
		}
		try {
			await markAllAsReadAPI(ids)
		} catch (_) {}
	}, [dispatch, notificationSocket, unreadNotifications, markAllAsReadAPI])

	return {
		unreadNotifications,
		archivedNotifications,
		unreadCount,
		loadInitialNotifications,
		handleMarkAsRead,
		handleDismiss,
		handleMarkAllAsRead,
		loadArchivedNotifications,
	}
}
